import React, { useContext, useState } from 'react'
import Sidebar from './Sidebar'
import DataTable, { defaultThemes } from 'react-data-table-component'
import TableVideo from './Video/TableVideo'
import { addcontext } from '../ContextShare/ContextShare'
import TableMember from './Member/TableMember'
import TableKla from './Kla/TableKla'
import TableSession from './Session/TableSession'
import TableEvents from './Events/TableEvents'
import TableAdmin from './Manage-Admin/TableAdmin'
import TableMedia from './Media/TableMedia'
import TableComplaints from './Complaints/TableComplaints'
import { useNavigate } from 'react-router-dom'
import FilterTable from './FilterTable'
import klaimage from '../Assets/kla-logo.png'
import DbStatus from './DbStatus/DbStatus'
import Home from './AdminHome.jsx/Home'
import TableConstituency from './Constituency/TableConstituency'
import TableRole from './Role/TableRole'
import TableSalutation from './Salutation/TableSalutation'
import TableGovAddress from './GovernerAddress/TableGovAddress'
import TableBsAdmin from './BudgetSpeech/TableBsAdmin'
import TableRulings from './Rulings.jsx/TableRulingsAdmin'
import ManageSittingsTable from './ManageSittings/ManageSittingsTable'
import ProgressChart from './AdminHome.jsx/ProgressChart'
import MemberListLessDetails from './Member/MemberListLessDetails'

function ManageVideos() {
    const { addVideo, setAddVideo } = useContext(addcontext)
    const { addSession, setAddSession } = useContext(addcontext)
    const { addMember, setaddMember } = useContext(addcontext)
    const { addKLA, setaddKLA } = useContext(addcontext)
    const { addEvent, setaddEvent } = useContext(addcontext)
    const { addConstituency, setaddConstituency } = useContext(addcontext)
    const { addRole, setaddRole } = useContext(addcontext)
    const { addSalutation, setaddSalutation } = useContext(addcontext)
    const { addGovAddress, setaddGovAddress } = useContext(addcontext)
    {/*useContext hook is used to extract the tableSelectedFromSidebar and 
    the settableSelectedFromSidebar from 'addcontext' context.*/}
    const { tableSelectedFromSidebar, settableSelectedFromSidebar } = useContext(addcontext)
    const { changeSeqNo, setChangeSeqNo } = useContext(addcontext)
    const { changeSeqNoGA, setChangeSeqNoGA } = useContext(addcontext)
    const { changeSeqNoBS, setChangeSeqNoBS } = useContext(addcontext)
    const { addBudSpeech, setaddBudSpeech } = useContext(addcontext)
    const [isSideBarOpen, setisSideBarOpen] = useState(false)
    const { changeSeqNoRL, setChangeSeqNoRl } = useContext(addcontext)
    const { addrulings, setaddrulings } = useContext(addcontext)

    // const [tableSelected, settableSelected] = useState('video')

    //isFilterClicked is initilized to boolean value false
    const [isFilterClicked, setisFilterClicked] = useState(false)

    //when the sidebar icon for small screen is clicked handleSidebar is invoked and icon changes.
    //in smaller screens if the isSideBarOpen is true sidebar is visible otherwise sidebar is not visible
    const handleSidebar = () => {
        setisSideBarOpen(!isSideBarOpen)
    }


    const navigate = useNavigate()
    
    const handleChangeseqNo = () => {
        setChangeSeqNo(!changeSeqNo)
        setAddVideo(false)
    }
    const handleAddvideo = () => {
        setAddVideo(!addVideo)
        setChangeSeqNo(false)
    }
    const handleAddMember = () => {
        setAddSession(!addSession)
    }
    const handleMemberAdd = () => {
        setaddMember(!addMember)
    }
    const handleAddKLA = () => {
        setaddKLA(!addKLA)
    }
    const handleAddEvent = () => {
        setaddEvent(!addEvent)
    }
    const handleConstituency = () => {
        setaddConstituency(!addConstituency)
    }
    const handleRole = () => {
        setaddRole(!addRole)
    }
    const handleSalutation = () => {
        setaddSalutation(!addSalutation)
    }
    const handleGovAddress = () => {
        setaddGovAddress(!addGovAddress)
        setChangeSeqNoGA(false)

    }
    const handleChangeseqNoGA = () => {
        setChangeSeqNoGA(!changeSeqNoGA)
        setaddGovAddress(false)
    }
    const handldeBudgetSpeech = () => {
        setaddBudSpeech(!addBudSpeech)
        setChangeSeqNoBS(false)
    }
    const handleChangeseqNoBS = () => {
        setChangeSeqNoBS(!changeSeqNoBS)
        setaddBudSpeech(false)
    }
    const handldeRuliinggs = () => {
        setaddrulings(!addrulings)
        setChangeSeqNoRl(false)
    }


    const handleChangeseqNoRL = () => {
        setChangeSeqNoRl(!changeSeqNoRL)
        setaddrulings(false)
    }
    return (
        <>
            <div className='flex w-full h-full ' style={{ fontFamily: 'ropa sans' }}>
                <div className='flex flex-col w-full h-full'>

                    {/* top section */}
                    <div className='w-full h-24 flex flex-row bg-success mb-2 rounded border'>

                        {/* sidebar icon for small screens */}
                        <div className='SidebarIcon md:hidden flex w-1/12 items-center '>
                            <i class={!isSideBarOpen ? "fa-solid fa-bars fa-lg ms-2 cursor-pointer" : "fa-solid fa-x fa-lg ms-2 cursor-pointer"} onClick={handleSidebar}></i>
                        </div>

                        {/* logo on top */}
                        <div className='lg:flex hidden w-2/12 items-center'>
                            <img src={klaimage} className='w-6/12 ms-12 lg:flex hidden' alt="" />
                        </div>

                        <div className='flex justify-evenly w-full'>
                            {/* FILTER BOX IS HERE */}

                            {/* {tableSelectedFromSidebar == 'dbstatus' ?
                                null

                                : tableSelectedFromSidebar == 'home' ?
                                    null :
                                    <div className={`flex md:${tableSelectedFromSidebar == 'video' ? 'w-52' : 'w-2/12'} w-2/12 items-center h-full`}>
                                        
                                        {!isFilterClicked ? <button onClick={e => setisFilterClicked(!isFilterClicked)} className='p-1 flex w-full h-2/5 justify-center items-center rounded-xl hover:bg-blue-600 hover:text-white border border-blue-600 transition transform duration-500 ease-in-out'>
                                            <i class="fa-solid fa-filter md:me-3 me-1 lg:flex hidden"></i>
                                            <span>Filters</span>
                                        </button>
                                            :
                                            <button onClick={e => setisFilterClicked(!isFilterClicked)} className='p-1 flex w-full h-2/5 justify-center items-center rounded-xl hover:bg-blue-600 hover:text-white border border-blue-600 transition transform duration-500 ease-in-out'>
                                                <i className="fa-solid fa-xmark md:me-3 me-1 lg:flex hidden"></i>
                                                <span>Close</span>
                                            </button>
                                        }
                                    </div>} */}

                            {/* FILTER BOX IS END HERE */}

                            {/* Search */}
                            {/* {tableSelectedFromSidebar == 'dbstatus' ? null :
                                <div className={`flex md:${tableSelectedFromSidebar == 'video' ? 'w-52' :tableSelectedFromSidebar=='governorsAddress'?'w-52':tableSelectedFromSidebar=='budgetSpeech'?'w-52':tableSelectedFromSidebar=='rulings'?'w-52':'w-0'} w-5/12 items-center h-full`}>
                                    <div className='flex w-full h-2/5 justify-center items-center rounded-xl border border-blue-600 focus:border-2 focus:bg-red-500'>
                                        <i class="fa-solid fa-magnifying-glass md:me-3 me-1 ms-3"></i>
                                        <input type="text" placeholder='Search' className='rounded-xl w-full h-full ' style={{ border: 'none', outline: 'none' }} />
                                    </div>
                                </div>} */}

                            {/* {tableSelectedFromSidebar=='home'&&<div className='w-full '><ProgressChart/></div>} */}

                            {tableSelectedFromSidebar == 'home' && <div className='flex justify-center items-center w-full'>
                                <h1 className='text-4xl text-blue-gray-800'>Admin Dashboard</h1>
                            </div>}


                            {/* Add new button */}
                            {/* Whenever an option from sidebar is chosen, the value stored in tableSelectedFromSidebar is used to update the name of the Add new button to Add new video,Add new member etc..
                        based on the value in tableSelectedFromSidebar*/}
                            <div className={`flex ${tableSelectedFromSidebar == 'video' ? 'md:w-52' : 'md:w-2/12'} w-4/12 items-center h-full`}>
                                {tableSelectedFromSidebar == 'video' ?
                                    <button className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}
                                        onClick={handleAddvideo}>
                                        <i class={`fa-solid ${addVideo ? 'fa-xmark' : 'fa-plus'} md:me-2 me-1`}></i>
                                        <span className='lg:text-sm text-xs'>{!addVideo ? 'Add new videos' : 'Close'}</span>
                                    </button>

                                    : tableSelectedFromSidebar == 'member' ?
                                        <button onClick={handleMemberAdd} className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}
                                        >
                                            <i class={`fa-solid ${addMember ? 'fa-xmark' : 'fa-plus'} md:me-2 me-1`}></i>
                                            <span className='lg:text-sm text-xs'>{!addMember ? 'Add new member' : 'Close'}</span>
                                        </button>

                                        : tableSelectedFromSidebar == 'kla' ?
                                            <button onClick={handleAddKLA} className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}>
                                                <i class={`fa-solid ${addKLA ? 'fa-xmark' : 'fa-plus'} md:me-2 me-1`}></i>
                                                <span className='lg:text-sm text-xs'>{!addKLA ? 'Add new kla' : 'Close'}</span>
                                            </button>

                                            : tableSelectedFromSidebar == 'session' ?
                                                <button onClick={handleAddMember} className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}>
                                                    <i class={`fa-solid ${addSession ? 'fa-xmark' : 'fa-plus'} md:me-2 me-1`}></i>
                                                    <span className='lg:text-sm text-xs'>{!addSession ? 'Add new session' : 'Close'}</span>
                                                </button>

                                                : tableSelectedFromSidebar == 'event' ?
                                                    <button onClick={handleAddEvent} className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}>
                                                        <i class={`fa-solid ${addEvent ? 'fa-xmark' : 'fa-plus'} md:me-2 me-1`}></i>
                                                        <span className='lg:text-sm text-xs'>{!addEvent ? 'Add new event' : 'Close'}</span>
                                                    </button>

                                                    : tableSelectedFromSidebar == 'constituency' ?
                                                        <button onClick={handleConstituency} className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}>
                                                            <i class={`fa-solid ${addConstituency ? 'fa-xmark' : 'fa-plus'} md:me-2 me-1`}></i>
                                                            <span className='lg:text-sm text-xs'>{!addConstituency ? 'Add new constituency' : 'Close'}</span>
                                                        </button>

                                                        : tableSelectedFromSidebar == 'role' ?
                                                            <button onClick={handleRole} className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}>
                                                                <i class={`fa-solid ${addRole ? 'fa-xmark' : 'fa-plus'} md:me-2 me-1`}></i>
                                                                <span className='lg:text-sm text-xs'>{!addRole ? 'Add new role' : 'Close'}</span>
                                                            </button>

                                                            : tableSelectedFromSidebar == 'salutation' ?
                                                                <button onClick={handleSalutation} className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}>
                                                                    <i class={`fa-solid ${addSalutation ? 'fa-xmark' : 'fa-plus'} md:me-2 me-1`}></i>
                                                                    <span className='lg:text-sm text-xs'>{!addSalutation ? 'Add new salutation' : 'Close'}</span>
                                                                </button>


                                                                : tableSelectedFromSidebar == 'admin' ?
                                                                    <button onClick={e => navigate('addadmin')} className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}>
                                                                        <i class="fa-solid fa-plus md:me-3 me-1"></i>
                                                                        <span className='lg:text-sm text-xs'>Add new admin</span>
                                                                    </button>

                                                                    : tableSelectedFromSidebar == 'media' ?
                                                                        <button className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}>
                                                                            <i class="fa-solid fa-plus md:me-3 me-1"></i>
                                                                            <span className='lg:text-sm text-xs'>Add new media</span>
                                                                        </button>

                                                                        :
                                                                        tableSelectedFromSidebar == 'governorsAddress' ?
                                                                            <button className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}
                                                                                onClick={handleGovAddress}>
                                                                                <i class={`fa-solid ${addGovAddress ? 'fa-xmark' : 'fa-plus'} md:me-2 me-1`}></i>
                                                                                <span className='lg:text-sm text-xs'>{!addGovAddress ? 'Add new videos' : 'Close'}</span>
                                                                            </button>

                                                                            :
                                                                            tableSelectedFromSidebar == 'budgetSpeech' ?
                                                                                <button className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}
                                                                                    onClick={handldeBudgetSpeech}>
                                                                                    <i class={`fa-solid ${addBudSpeech ? 'fa-xmark' : 'fa-plus'} md:me-2 me-1`}></i>
                                                                                    <span className='lg:text-sm text-xs'>{!addBudSpeech ? 'Add new videos' : 'Close'}</span>
                                                                                </button>
                                                                                :
                                                                                tableSelectedFromSidebar == 'rulings' ?
                                                                                    <button className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}
                                                                                        onClick={handldeRuliinggs}>
                                                                                        <i class={`fa-solid ${addrulings ? 'fa-xmark' : 'fa-plus'} md:me-2 me-1`}></i>
                                                                                        <span className='lg:text-sm text-xs'>{!addrulings ? 'Add new videos' : 'Close'}</span>
                                                                                    </button>
                                                                                    :

                                                                                    ''
                                    //  <button className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}>
                                    //     {/* <i class="fa-solid fa-plus md:me-3 me-1"></i> */}
                                    //     {/* <span>Add new media</span> */}
                                    // </button>

                                }
                            </div>

                            {/* change seq number */}
                            {tableSelectedFromSidebar == 'video' && tableSelectedFromSidebar != 'home' &&
                                (<div className='flex md:w-52 w-4/12 items-center h-full '>
                                    <button className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}
                                        onClick={handleChangeseqNo}>
                                        <i class={`fa-solid ${changeSeqNo ? 'fa-xmark' : 'fa-pen-to-square'} md:me-2 me-1`}></i>
                                        <span className='lg:text-sm text-xs'>{!changeSeqNo ? 'Change sequence number' : 'Close'}</span>
                                    </button>
                                </div>)}

                            {tableSelectedFromSidebar == 'governorsAddress' &&
                                <div className='flex md:w-52 w-4/12 items-center h-full '>
                                    <button className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}
                                        onClick={handleChangeseqNoGA}>
                                        <i class={`fa-solid ${changeSeqNoGA ? 'fa-xmark' : 'fa-pen-to-square'} md:me-2 me-1`}></i>
                                        <span className='lg:text-sm text-xs'>{!changeSeqNoGA ? 'Change sequence number' : 'Close'}</span>
                                    </button>
                                </div>}

                            {tableSelectedFromSidebar == 'budgetSpeech' &&
                                <div className='flex md:w-52 w-4/12 items-center h-full '>
                                    <button className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}
                                        onClick={handleChangeseqNoBS}>
                                        <i class={`fa-solid ${changeSeqNoBS ? 'fa-xmark' : 'fa-pen-to-square'} md:me-2 me-1`}></i>
                                        <span className='lg:text-sm text-xs'>{!changeSeqNoBS ? 'Change sequence number' : 'Close'}</span>
                                    </button>
                                </div>}

                            {tableSelectedFromSidebar == 'rulings' &&
                                <div className='flex md:w-52 w-4/12 items-center h-full '>
                                    <button className='flex w-full h-2/5 justify-center items-center rounded-xl  cursor-pointer text-white hover:border border-blue-gray-800' style={{ backgroundColor: '#0070FF' }}
                                        onClick={handleChangeseqNoRL}>
                                        <i class={`fa-solid ${changeSeqNoRL ? 'fa-xmark' : 'fa-pen-to-square'} md:me-2 me-1`}></i>
                                        <span className='lg:text-sm text-xs'>{!changeSeqNoRL ? 'Change sequence number' : 'Close'}</span>
                                    </button>
                                </div>}
 

                        </div>
                    </div>

                    {/* Filter box section */}
                    {/* If isFilterClicked is true then the FilterTable(table for selecting filters) is displayed otherwise it is hidden */}
                    <div className={`transition-opacity duration-500 ${isFilterClicked ? 'opacity-100' : 'opacity-0'} w-full  flex flex-row z-50 absolute`}>
                        {isFilterClicked && <div className={`transition-opacity duration-500 w-full  flex flex-row z-50 absolute mt-20`}>
                            <div className='lg:flex hidden md:w-2/12 w-0 items-center' >
                            </div>

                            <div className='flex justify-evenly w-full' >
                                {/* filter */}
                                {/* When mouse leaves this div containing FilterTable isFilterClicked is set to false and the table is hidden */}
                                <div className='flex md:w-2/12 w-8/12 items-center h-full' onMouseLeave={e => setisFilterClicked(false)}>
                                    <FilterTable />
                                </div>

                                <div className='flex md:w-4/12 w-0 items-center h-full'>
                                </div>
                                <div className='flex md:w-2/12 w-0 items-center h-full'>
                                </div>
                            </div>
                        </div>}

                    </div>

                    {/* Section two */}
                    <div className='flex flex-row'>

                        {/*SIDEBAR Sidebar displayed on large screens  */}

                        <Sidebar />


                        {/* sidebar for smaller screens */}
                        {/*If isSideBarOpen is true then sidebar is visible otherwise sidebar is hidden */}
                        {isSideBarOpen &&
                            <div className={`md:w-6/12  w-9/12 lg:hidden flex  bg-primary   flex-col text-white rounded-r z-40 ${isSideBarOpen && 'relative'}  `} style={{ height: '87vh' }}>
                                <Sidebar />
                            </div>
                        }

                        {/* Table */}
                        <div className={`lg:w-9/12 xl:w-10/12 w-full overflow-y-scroll hide-scroll-bar ${isSideBarOpen && 'absolute'}`} style={{ height: `${addVideo ? '100%' : '87vh'}` }}>
                            {tableSelectedFromSidebar == 'video' ? <TableVideo />
                                : tableSelectedFromSidebar == 'member' ? <MemberListLessDetails />
                                : tableSelectedFromSidebar == 'kla' ? <TableKla />
                                : tableSelectedFromSidebar == 'session' ? <TableSession />
                                : tableSelectedFromSidebar == 'event' ? <TableEvents />
                                : tableSelectedFromSidebar == 'admin' ? <TableAdmin />
                                : tableSelectedFromSidebar == 'media' ? <TableMedia />
                                : tableSelectedFromSidebar == 'complaints' ? <TableComplaints />
                                : tableSelectedFromSidebar == 'dbstatus' ? <DbStatus />
                                : tableSelectedFromSidebar == 'constituency' ? <TableConstituency />
                                : tableSelectedFromSidebar == 'role' ? <TableRole />
                                : tableSelectedFromSidebar == 'salutation' ? <TableSalutation />
                                : tableSelectedFromSidebar == 'governorsAddress' ? <TableGovAddress />
                                : tableSelectedFromSidebar == 'budgetSpeech' ? <TableBsAdmin />
                                : tableSelectedFromSidebar == 'rulings' ? <TableRulings />
                                : tableSelectedFromSidebar == 'manageSittings' ? <ManageSittingsTable />
                                : tableSelectedFromSidebar == 'membermap' ? <TableMember />
                                : <Home />
                            }
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default ManageVideos